import * as React from "react";
import * as PropTypes from "prop-types";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";

import * as Theme from "../../../../app/Theme";

import TSlideDrawer from "../../../common/TSlideDrawer";

import * as gbu from "../../../GB/GBUtil";

import PIContinuationRefForm from "../../Forms/Reference/PIContinuationRefForm";
import * as pias from "../../NonComponents/PIAppState";
import * as pip from "../../NonComponents/PIProps";
//import * as pic from "../../NonComponents/PIConst";
import * as php from "../../NonComponents/PIHelp";
import THelpButton from "../../../common/THelpButton";

class PIContinuationRefSlideDrawer extends React.Component {
  static propTypes = {
    [pias.helpAreaStr]: PropTypes.string,
    [pias.onHelp]: PropTypes.func,
    [pias.modVarObjList]: PropTypes.arrayOf(PropTypes.object),

    [pip.onToggleRefSlideDrawer]: PropTypes.func,
  };

  static defaultProps = {
    [pias.helpAreaStr]: php.config_Cont_RefRD_HP,
    [pias.onHelp]: () => console.log(pias.onHelp),

    [pip.onToggleRefSlideDrawer]: () => console.log(pip.onToggleRefSlideDrawer),
  };

  //==================================================================================================================
  //
  //                                        Life Cycle Events
  //
  //==================================================================================================================

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return gbu.shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
  }

  //==================================================================================================================
  //
  //                                              Event Handlers
  //
  //==================================================================================================================

  onHelpBtnClick = () => {
    this.props.onHelp();
  };

  //==================================================================================================================
  //
  //                                              Render
  //
  //==================================================================================================================

  render() {
    /* props */

    const props = this.props;
    const onToggleRefSlideDrawer = props[pip.onToggleRefSlideDrawer];
    const modVarObjList = this.props[pias.modVarObjList];

    /* state */

    //const state = this.state;

    const continuationRefFormComp = <PIContinuationRefForm {...{ [pias.modVarObjList]: modVarObjList }} />;

    const slideDrawer = (
      <TSlideDrawer
        anchor={"right"}
        onClose={onToggleRefSlideDrawer}
        content={continuationRefFormComp}
        headerTitleStyle={{
          color: Theme.PI_PrimaryColor,
        }}
        saveButton={false}
        title={RS(SC.GB_stDefContCurves)}
        width={Theme.slideDrawerLv2Width}
        helpBtn={<THelpButton Theme={Theme} onClick={this.onHelpBtnClick} />}
        level={2}
      />
    );

    return slideDrawer;
  }
}

export default PIContinuationRefSlideDrawer;
